import React from 'react';
 
function ActiveButtonWrapper({children}) {
   return <div className="activeButtonArea">{children}</div>
}
 
export default ActiveButtonWrapper;